export default "__VITE_ASSET__DnZuVlbw__"